// TaskDetail.jsx
import moment from 'moment';
import React from 'react';

const TaskDetail = ({ open, taskData, onClosed }) => {
  // console.log("detail task component",taskData)
  if (!open || !taskData) return null;
  return (
    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
      <div className=" bg-gradient-to-br from-blue-50 to-blue-200  p-6 rounded-xl w-[400px] md:w-[800px] max-h-[80vh] overflow-y-auto">

        <h2 className="text-xl font-bold mb-3">{taskData?.PROJECTTITLE}</h2>

        <img
          src={taskData?.IMAGE}
          alt="Employee"
          className="w-24 h-24 object-cover rounded-full mx-auto mb-3"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">

          {/* Info Card */}
          <div className="bg-blue-50 p-3 rounded-lg border border-blue-200 shadow-sm">
            <p className="text-xs font-semibold text-blue-700 mb-1">Employee Info</p>

            <div className="flex justify-between">
              <span className="font-medium text-gray-700">Employee:</span>
              <span className="text-gray-900">{taskData?.EMPLOYEE_NAME ?? "-"}</span>
            </div>

            <div className="flex justify-between">
              <span className="font-medium text-gray-700">Department:</span>
              <span className="text-gray-900">{taskData?.DEPARTMENT_TITLE ?? "-"}</span>
            </div>

            <div className="flex justify-between">
              <span className="font-medium text-gray-700">Designation:</span>
              <span className="text-gray-900">{taskData?.DESIGNATION_TITLE ?? "-"}</span>
            </div>
          </div>

          {/* Task Details */}
          <div className="bg-blue-50 p-3 rounded-lg border border-blue-200 shadow-sm">
            <p className="text-xs font-semibold text-blue-700 mb-1">Task Details</p>

            <div className="flex justify-between">
              <span className="font-medium text-gray-700">Work Type:</span>
              <span className="text-gray-900">{taskData?.WORK_TYPE ?? "-"}</span>
            </div>

            <div className="flex justify-between">
              <span className="font-medium text-gray-700">Status:</span>
              <span className="text-gray-900">{taskData?.STATUS ?? "-"}</span>
            </div>

            <div className="flex justify-between">
              <span className="font-medium text-gray-700">Subject:</span>
              <span className="text-gray-900">{taskData?.CLIENTTITLE ?? "-"}</span>
            </div>
          </div>

          {/* Complain & Approval */}
          <div className="bg-blue-50 p-3 rounded-lg border border-blue-200 shadow-sm">
            <p className="text-xs font-semibold text-blue-700 mb-1">Complain & Approval</p>

            <div className="flex justify-between">
              <span className="font-medium text-gray-700">Complain By:</span>
              <span className="text-gray-900">{taskData?.COMPLAINBY ?? "-"}</span>
            </div>

            <div className="flex justify-between">
              <span className="font-medium text-gray-700">Complain Date:</span>
              <span className="text-gray-900">
                {taskData?.COMPLAINDATE ? moment(taskData?.COMPLAINDATE).format("DD-MM-YY") : "-"}
              </span>
            </div>

            <div className="flex justify-between">
              <span className="font-medium text-gray-700">Approve By:</span>
              <span className="text-gray-900">{taskData?.APPROVEBY ?? "-"}</span>
            </div>
          </div>

          {/* Dates Section */}
          <div className="bg-blue-50 p-3 rounded-lg border border-blue-200 shadow-sm">
            <p className="text-xs font-semibold text-blue-700 mb-1">Dates</p>

            <div className="flex justify-between">
              <span className="font-medium text-gray-700">Assign Date:</span>
              <span className="text-gray-900">
                {taskData?.ASSIGNDATE ? moment(taskData?.ASSIGNDATE).format("DD-MM-YY") : "-"}
              </span>
            </div>

            <div className="flex justify-between">
              <span className="font-medium text-gray-700">Due Date:</span>
              <span className="text-gray-900">
                {taskData?.DUEDATE ? moment(taskData?.DUEDATE).format("DD-MM-YY") : "-"}
              </span>
            </div>

            <div className="flex justify-between">
              <span className="font-medium text-gray-700">Complete Date:</span>
              <span className="text-gray-900">
                {taskData?.COMPLETEDATE ? moment(taskData?.COMPLETEDATE).format("DD-MM-YY") : "-"}
              </span>
            </div>
          </div>

          {/* Description */}
        </div>
          <div className="bg-blue-50 p-3 mt-3 rounded-lg border border-blue-200 shadow-sm ">
            <p className="text-xs font-semibold text-blue-700 mb-1">Description</p>
            <p className="text-gray-900 whitespace-pre-line">{taskData?.DESCRIPTION ?? "-"}</p>
            <p className="text-xs font-semibold text-blue-700 mb-1">Developer Review</p>

            <p className="text-gray-900 whitespace-pre-line">{taskData?.DEVELOPER_REVIEW ?? "-"}</p>
            <p className="text-xs font-semibold text-blue-700 mb-1">Client Review</p>

            <p className="text-gray-900 whitespace-pre-line">{taskData?.CLIENT_REVIEW ?? "-"}</p>
          </div>


        <button
          onClick={onClosed}
          className="mt-4 px-4 py-2 bg-red-500 text-white rounded w-full"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default TaskDetail;
